export var appsM365AppId = 'apps'; // The ID for the Apps M365 app
//# sourceMappingURL=constants.js.map